export const API_BASE_URL = window.location.hostname === "localhost" ? "https://localhost:3001" : window.location.origin;
export const ODOO_BASE_URL = "https://erp.seema.de";
export const IGNORED_LOOKUP_DOMAINS = new Set(["seema.de"]);
